module.exports = __webpack_public_path__ + "img/icon_dialog_qq_hover.c3cafb25.svg";